import React, { useEffect, useState } from 'react'
import { Button, Form, FormGroup, Input, Label } from 'reactstrap'
import { useParams } from 'react-router-dom'
import EmailEditor from '../../components/Email/EmailEditor'
import EmailLayout from '../../components/Email/EmailLayout'
import CAlert from '../../components/sharedComponents/CAlert'
import { getEmailTemplateById, patchEmailTemplate } from '../../actions/emailTemplateAction'

const EditEmailTemplate = props => {
    const { authenticated, userDetails } = props
    const { id } = useParams()

    const [templateId, setTemplateId] = useState(null)
    const [name, setName] = useState('')
    const [subject, setSubject] = useState('')
    const [editorValue, setEditorValue] = useState('')
    const [initEditorValue, setInitEditorValue] = useState('')
    const [isUpdated, setIsUpdated] = useState(false)
    const [errorText, setErrorText] = useState(null)
    const [isLoading, setIsloading] = useState(false)

    useEffect(() => {
        setIsloading(true)

        const fetchData = async () => {
            await getEmailTemplateById(id, (res) => {
                setTemplateId(res._id)
                setName(res.name)
                setSubject(res.subject)
                setInitEditorValue(res.content)
            }, renderError)
        }
        fetchData();

        setIsloading(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id])

    function templateUpdated() {
        setIsUpdated(true)
    }

    function renderError(err) {
        setErrorText(err)
        isLoading && setIsloading(false)
        return
    }

    const handleOnCreate = async e => {
        e.preventDefault()

        if (!authenticated || name === '') return

        const user_id = userDetails.user._id

        const reqBody = {
            _id: templateId,
            user_id,
            name,
            subject,
            content: editorValue
        }
        setIsloading(true)
        await patchEmailTemplate(reqBody, () => {
            setIsUpdated(true)
            templateUpdated()
            setIsloading(false)
        }, renderError)
    }

    return <EmailLayout title='Edit Email Template'>
        <CAlert show={errorText !== null} text={errorText} color='danger' />
        <CAlert onClick={() => setIsUpdated(false)} show={isUpdated} text='Successfully Updated!' color='success' timeout />

        <Form onSubmit={e => handleOnCreate(e)}>
            <FormGroup>
                <Label>Template Name</Label>
                <Input
                    type="text"
                    value={name || ''}
                    placeholder="name"
                    onChange={e => setName(e.target.value)}
                    disabled={isUpdated}
                    required
                />
            </FormGroup>
            <FormGroup>
                <Label>Subject</Label>
                <Input
                    type="text"
                    value={subject || ''}
                    placeholder="subject"
                    onChange={e => setSubject(e.target.value)}
                    disabled={isUpdated}
                    required
                />
            </FormGroup>

            <Label for="exampleSelect">Content</Label>
            <EmailEditor disabled={isUpdated}
                reset={isUpdated} initialValue={isUpdated ? editorValue : initEditorValue}
                editorChange={(value) => setEditorValue(value)} />
            <br />
            <center>
                <Button color='info'>Edit Template</Button>
            </center>
        </Form>

    </EmailLayout>
}

export default EditEmailTemplate;
